import {
  Extension,
  IExtensionValueCodeableConcept,
  IExtensionValueUri,
  IExtensionValueBoolean,
  IExtensionValueInteger,
} from '.';

export function isExtensionBoolean(
  extension: Extension,
): extension is IExtensionValueBoolean {
  return (extension as IExtensionValueBoolean).valueBoolean !== undefined;
}

export function isExtensionInteger(
  extension: Extension,
): extension is IExtensionValueInteger {
  return (extension as IExtensionValueInteger).valueInteger !== undefined;
}

export function isExtensionCodeableConcept(
  extension: Extension,
): extension is IExtensionValueCodeableConcept {
  return (
    (extension as IExtensionValueCodeableConcept).valueCodeableConcept !==
    undefined
  );
}

export function isExtensionUri(
  extension: Extension,
): extension is IExtensionValueUri {
  return (extension as IExtensionValueUri).valueUri !== undefined;
}
